import React from 'react';
import { MainLayout } from 'layouts/MainLayout';
import { LocationScopedSettings } from 'components/settings/LocationScopedSettings';
import { LocationsAndFavouritesSettings } from 'components/settings/LocationSettings';
import { MERCHANT_MOBILE_SETTINGS } from 'config/routes';

export const LocationsAndFavouritesSettingsPage: React.FC = () => (
    <MainLayout
        pageName="Locations and Favourites Settings"
        pageDescription="Adjust your Locations and Favourites settings."
        breadcrumbs={[{ label: 'Settings', url: MERCHANT_MOBILE_SETTINGS }]}
    >
        <LocationScopedSettings globalComponent={LocationsAndFavouritesSettings} />
    </MainLayout>
);
